import React from 'react';
/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from 'components/Loader';
import { getQueryValue } from 'utils/'

// components
import { withStyles } from '@material-ui/core/styles';
import DashboardPage from './components/DashboardPage';

const styles = theme => ({
  test: {
    padding: '20px',
  },
});

class MyDashboard extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentDidMount() {
    this.props.dispatch(actions.getData());
  }
  render() {
    const { loading, history } = this.props;
    if (loading) {
      return <Loader />;
    } else {
      return (
        <div style={{ "width": "100%" }}>
          <DashboardPage tab={getQueryValue("tab", history.location.pathname + history.location.search)} data={this.props} />
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(MyDashboard));
